import React from "react";
import { ReportEditor } from "./editor/ReportEditor";

export const CreateReportTemplate = () => {
  return <ReportEditor mode={"create"} onClose={() => null} />;
};
